import API from 'services/API/index';
import Bank from '../../classes/Bank';
import { get } from 'lodash';

export default function requestToBank() {
  return API.request({
    method: 'GET',
    url: `/settings?objectType=BB`,
    mapper: function (data) {
      const allBanks = get(data, 'ALL_BANKS.parameters.objects');
      return allBanks.map((bankConfig) => new Bank(bankConfig));
    },
  });
}
